/**
 * DiscoveryFanbasesProfile 컴포넌트
 * @description 시트·모달 안에 서는 팬베이스 요약 — 얼굴 · 이름 · 아이디 · 소개글 · 멤버 수.
 *   더 많은 것(글 · 참여)은 앱에 있다.
 */
import { Avatar } from "@fanwork-web/design-system";
import { memo } from "react";

import {
  DISCOVERY_FANBASE_PROFILE_AVATAR_SIZE,
  DISCOVERY_FANBASE_PROFILE_AVATAR_WIDTH,
  discoveryFanbaseProfileStyles,
} from "./DiscoveryFanbases.styles";
import type { DiscoveryFanbasesProfileProps } from "./DiscoveryFanbases.types";

import { EXPLORE_COPY } from "../../constants/copy";
import { AppImage } from "@/shared/ui";

const DiscoveryFanbasesProfile = memo<DiscoveryFanbasesProfileProps>(
  ({ fanbase }) => (
    <div className={discoveryFanbaseProfileStyles.root}>
      {fanbase.profileImageUrl ? (
        <Avatar
          type="image"
          size={DISCOVERY_FANBASE_PROFILE_AVATAR_SIZE}
          image={
            <AppImage
              uri={fanbase.profileImageUrl}
              targetWidth={DISCOVERY_FANBASE_PROFILE_AVATAR_WIDTH}
            />
          }
          accessibilityLabel={fanbase.name}
        />
      ) : (
        <Avatar
          type="initial"
          size={DISCOVERY_FANBASE_PROFILE_AVATAR_SIZE}
          initial={fanbase.name.charAt(0).toUpperCase()}
        />
      )}
      <div className={discoveryFanbaseProfileStyles.texts}>
        <p className={discoveryFanbaseProfileStyles.name}>{fanbase.name}</p>
        <p className={discoveryFanbaseProfileStyles.username}>
          @{fanbase.handle}
        </p>
        <p className={discoveryFanbaseProfileStyles.reason}>
          {EXPLORE_COPY.fanbases.memberCount(fanbase.memberCount)}
        </p>
        {fanbase.bio ? (
          <p className={discoveryFanbaseProfileStyles.reason}>{fanbase.bio}</p>
        ) : null}
      </div>
    </div>
  ),
);

DiscoveryFanbasesProfile.displayName = "DiscoveryFanbasesProfile";

export default DiscoveryFanbasesProfile;
